import script from "./NavComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavComponent.vue?vue&type=script&setup=true&lang=js"

import "./NavComponent.vue?vue&type=style&index=0&id=23c29ff8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23c29ff8"]])

export default __exports__